import React, { memo, useContext } from 'react';
import PropTypes from 'prop-types';
import { AppContext } from '@prisjakt/ui-app-context';
import { bemGenerator } from '@prisjakt/ui-base';
import InfoPageLink from '../../../../components/info-page-link';

import './index.scss';

const styles = bemGenerator('price-information', ['info-page-link']);

const PriceInformation = props => {
  const { t, market } = useContext(AppContext);

  if (!market.modules.priceInfo.enabled) {
    return null;
  }

  return (
    <div className={styles.block}>
      <div>
        {t('product', 'price-comparison-information.featured-stores-ratio', {
          totalCount: props.storeStatistics.totalCount,
          featuredCount: props.storeStatistics.featuredCount,
        })}
        <br />
        {t('product', 'price-comparison-information.listed-stores-information')}
      </div>
      <div className={styles['info-page-link']}>
        <InfoPageLink id={market.infoPageMap.priceInformation}>
          {t('product', 'price-comparison-information.read-more')}
        </InfoPageLink>
      </div>
    </div>
  );
};

const { number, shape } = PropTypes;

PriceInformation.propTypes = {
  storeStatistics: shape({
    totalCount: number.isRequired,
    featuredCount: number.isRequired,
  }).isRequired,
};

export default memo(PriceInformation);
